import { Trans, useLingui } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import {
  apiGetClinicalStudiesByStudyAcronymOverviewOverallOptions,
  PerPatientStudyStatsSimple,
} from "../../api";
import { ApiConnector } from "../../api/api-connector";
import { FormRow } from "../../components/ui-kit/form/form-row";
import { FormTable } from "../../components/ui-kit/form/form-table";
import { Spinner } from "../../components/ui-kit/spinner";
import { assertStudyAcronym } from "../../utils/clinical-studies";
import { OverviewTable } from "./overview-table.tsx";

export function OverviewRoute(props: { api: ApiConnector }) {
  const { t } = useLingui();
  const { name } = useParams<{ name: string }>();
  const study = assertStudyAcronym(name);

  const { data } = useQuery(
    apiGetClinicalStudiesByStudyAcronymOverviewOverallOptions({
      path: { study_acronym: study },
    }),
  );

  return !data ? (
    <Spinner />
  ) : (
    <>
      <FormTable>
        <FormRow label={t`Full title`} data={data.full_title} />

        <FormRow label={t`Planned patients`} data={data.planned_patients} />

        <FormRow label={t`No. planned visits`} data={data.no_planned_visits} />

        <FormRow label={t`Enrolled patients`} data={data.enrolled_patients} />
      </FormTable>

      <h2 className="mt-10 mb-2 text-base font-bold">
        <Trans>Patient visits</Trans>
      </h2>

      <OverviewTable
        data={data.visits_per_patients as PerPatientStudyStatsSimple[]}
        study={study}
      />
    </>
  );
}
